import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="invoiceInfo";

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function syncInfo(id){
  console.log("sync:",id)
  return axios({
    url: `/ws/${moduleName}/sync/${id}`,
    method: 'get',
  })
}

export function getByBusinessIdAndType(id,type){
  console.log("data:",id)
  return axios({
    url: `/ws/${moduleName}/getByBusinessIdAndType/${id}/${type}`,
    method: 'get'
  })
}

export function getByDealConfrimId(id){
  console.log("data:",id)
  return axios({
    url: `/ws/${moduleName}/getByDealConfrimId/${id}`,
    method: 'get'
  })
}

export default {
  update:update,
  getByBusinessIdAndType,
  getByDealConfrimId,
  syncInfo
}